import { RepeatIcon } from "@chakra-ui/icons";
import {
  Text,
  useToast,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
  HStack,
  IconButton,
  Flex,
  Button,
} from "@chakra-ui/react";
import { useState } from "react";
import {
  useUpdateCourseAssetIdMutation,
  useUpdateSpotAssetIdMutation,
  useGetCourseAssetIdQuery,
} from "./index.generated";
import { SpotForSidebar } from "../convertType";

export const CourseAssetIdEditable = ({ courseId }: { courseId: string }) => {
  const toast = useToast();
  const [updateCourseIdRes, update] = useUpdateCourseAssetIdMutation();

  const [getCourseAssetIdRes] = useGetCourseAssetIdQuery({
    variables: { id: courseId },
  });

  const [assetId, setAssetId] = useState(
    getCourseAssetIdRes.data?.course.assetId.toString()
  );

  const updateCourseId = (assetId: String) => {
    if (isNaN(parseInt(assetId.toString()))) {
      toast({
        title: "コースIDは数値で指定してください",
        status: "warning",
      });
      return;
    }
    if (
      parseInt(assetId.toString()) < 0 ||
      parseInt(assetId.toString()) > 999
    ) {
      toast({
        title: "コースIDは0から999の範囲で指定してください",
        status: "warning",
      });
      return;
    }

    update({
      id: courseId,
      assetId: parseInt(assetId.toString()),
    }).then((res) => {
      if (res.error) {
        if (res.error.message.includes("Asset ID already exists")) {
          toast({
            title: "このコースIDはすでに存在します",
            status: "warning",
          });
          return;
        }
        toast({
          title: "コースIDの更新に失敗しました",
          status: "error",
        });
        console.error(res.error);
      } else {
        toast({
          title: "コースIDを更新しました",
          status: "success",
        });
      }
    });
  };

  return (
    <>
      {import.meta.env.VITE_FEATURE_FLAG_ENABLE_ASSET_EDITOR == "true" && (
        <HStack w="full" align="center">
          <Flex direction="row" w="full" justify="space-between">
            <HStack>
              <Text>コースID</Text>
              <NumberInput
                value={assetId}
                min={0}
                max={999}
                width="20"
                onChange={(valueString) => {
                  setAssetId(valueString);
                }}
                allowMouseWheel
              >
                <NumberInputField />
                <NumberInputStepper>
                  <NumberIncrementStepper textColor={"white"} />
                  <NumberDecrementStepper textColor={"white"} />
                </NumberInputStepper>
              </NumberInput>
              <IconButton
                variant={"outline"}
                textColor={"white"}
                aria-label="reset asset id"
                outlineOffset={1}
                icon={<RepeatIcon />}
                onClick={() => {
                  setAssetId(
                    getCourseAssetIdRes.data?.course.assetId.toString()
                  );
                }}
              />
            </HStack>
            <Button
              size="sm"
              rounded="full"
              variant={"outline"}
              textColor={"white"}
              onClick={() => {
                if (assetId !== undefined) {
                  updateCourseId(assetId);
                }
              }}
            >
              コースID更新
            </Button>
          </Flex>
        </HStack>
      )}
    </>
  );
};

export const SpotAssetIdEditable = ({ spot }: { spot: SpotForSidebar }) => {
  const toast = useToast();
  const [updateCourseIdRes, update] = useUpdateSpotAssetIdMutation();
  const [assetId, setAssetId] = useState(spot.assetId.toString());
  const [nowAssetId, setNowAssetId] = useState(spot.assetId.toString());
  const updateCourseId = (assetId: String) => {
    if (isNaN(parseInt(assetId.toString()))) {
      toast({
        title: "スポットIDは数値で指定してください",
        status: "warning",
      });
      return;
    }
    if (
      parseInt(assetId.toString()) < 0 ||
      parseInt(assetId.toString()) > 9999
    ) {
      toast({
        title: "スポットIDは0から9999の範囲で指定してください",
        status: "warning",
      });
      return;
    }
    update({
      id: spot.id,
      assetId: parseInt(assetId.toString()),
    }).then((res) => {
      if (res.error) {
        if (res.error.message.includes("Asset ID already exists")) {
          toast({
            title: "このスポットIDはすでに存在します",
            status: "warning",
          });
          return;
        }
        toast({
          title: "スポットIDの更新に失敗しました",
          status: "error",
        });
        console.error(res.error);
      } else {
        toast({
          title: "スポットIDを更新しました",
          status: "success",
        });
      }
    });
  };

  return (
    <>
      {import.meta.env.VITE_FEATURE_FLAG_ENABLE_ASSET_EDITOR == "true" && (
        <HStack w="full">
          <Flex direction="row" w="full" justify="space-between">
            <HStack>
              <Text fontSize="sm">スポットID</Text>
              <NumberInput
                value={assetId}
                min={0}
                max={9999}
                size="sm"
                width="20"
                onChange={(valueString) => {
                  setAssetId(valueString);
                }}
                allowMouseWheel
              >
                <NumberInputField max={9999} min={0} />
                <NumberInputStepper>
                  <NumberIncrementStepper textColor={"white"} />
                  <NumberDecrementStepper textColor={"white"} />
                </NumberInputStepper>
              </NumberInput>
              <IconButton
                variant={"outline"}
                textColor={"white"}
                aria-label="reset asset id"
                size={"sm"}
                icon={<RepeatIcon />}
                colorScheme="facebook"
                onClick={() => {
                  setAssetId(nowAssetId);
                }}
              />
            </HStack>
            <Button
              size="sm"
              rounded="full"
              variant={"outline"}
              textColor={"white"}
              onClick={() => {
                if (assetId !== undefined) {
                  updateCourseId(assetId);
                  setNowAssetId(assetId);
                }
              }}
            >
              スポットID更新
            </Button>
          </Flex>
        </HStack>
      )}
    </>
  );
};
